import RenderToast from "@/components/RenderToast";
import { extractErrors } from "@/utils/helper";
import { useEffect } from "react";

const useFormikErrorToast = (formik) => {
  useEffect(() => {
    if (
      formik.isSubmitting &&
      !formik.isValidating &&
      Object.keys(formik.errors).length
    ) {
      const errorMessage = extractErrors(formik.errors);
      RenderToast({ type: "error", message: errorMessage });
    }
  }, [formik.errors, formik.isSubmitting, formik.isValidating]);
};

export default useFormikErrorToast;
